// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__yxu1g","header":"MergedInvoice_header__io-mD"};